export const FORM_STATES = {
	LOADING: 'LOADING',
	FORM: 'FORM',
	DOWNLOAD: 'DOWNLOAD',
	ERROR: 'ERROR'
};
export const ERRORS = {
	LLS: 'LLS',
	DOWNLOAD: 'DOWNLOAD',
	GENERAL: 'GENERAL'
};

export const CALLBACK_REASONS = [
	{ value: 'INCORRECT_AMOUNT', text: 'Nem a kívánt összeget utaltam át' },
	{ value: 'INCORRECT_ACCOUNT', text: 'Hibás számlára/hibás másodlagos számlaazonosítóra utaltam át' },
	{ value: 'MISUSE', text: 'Visszaélés gyanú' }
];
export const TRANSFER_CHANNEL = [
	{ value: 'ELECTRONIC', text: 'Elektronikus csatornán benyújtott megbízás' },
	{ value: 'PHONE', text: 'Telefonos ügyintézői szolgáltatáson keresztül benyújtott megbízás' },
	{ value: 'BANK', text: 'Bankfiókban benyújtott megbízás' }
];
export const TRANSFER_TYPE = [
	{ value: 'ADHOC', text: 'Eseti átutalás, terhelési nap feltüntetésével megadott eseti átutalás, rendszeres átutalás' },
	{ value: 'GROUP', text: 'Csoportos átutalás egyedi tétele' },
	{ value: 'VIBER', text: 'VIBER átutalás' }
];
export const OWNERSHIP = [
	{ key: 'OWNER', value: 'Számlatulajdonos' },
	{ key: 'PERMANENT_REPRESENTATIVE', value: 'Állandó meghatalmazott' }
];
export const SECONDARY_ACCOUNT = [
	{ key: true, value: 'Igen' },
	{ key: false, value: 'Nem' }
];
export const CURRENCIES = [
	{ currencyCode: 'AUD', hungarianName: 'Ausztrál dollár' },
	{ currencyCode: 'BGN', hungarianName: 'Bolgár leva' },
	{ currencyCode: 'CAD', hungarianName: 'Kanadai dollár' },
	{ currencyCode: 'CHF', hungarianName: 'Svájci frank' },
	{ currencyCode: 'CNY', hungarianName: 'Kínai juan' },
	{ currencyCode: 'CZK', hungarianName: 'Cseh korona' },
	{ currencyCode: 'DKK', hungarianName: 'Dán korona' },
	{ currencyCode: 'EUR', hungarianName: 'Euro' },
	{ currencyCode: 'GBP', hungarianName: 'Angol font' },
	{ currencyCode: 'HRK', hungarianName: 'Horvát kuna' },
	{ currencyCode: 'HUF', hungarianName: 'Magyar forint' },
	{ currencyCode: 'JPY', hungarianName: 'Japán yen' },
	{ currencyCode: 'MXN', hungarianName: 'Mexikói peso' },
	{ currencyCode: 'NOK', hungarianName: 'Norvég korona' },
	{ currencyCode: 'NZD', hungarianName: 'Új-Zélandi dollár' },
	{ currencyCode: 'PLN', hungarianName: 'Lengyel zloty' },
	{ currencyCode: 'RON', hungarianName: 'Új Román lej' },
	{ currencyCode: 'RSD', hungarianName: 'Szerb dinár' },
	{ currencyCode: 'RUB', hungarianName: 'Orosz rubel' },
	{ currencyCode: 'SEK', hungarianName: 'Svéd korona' },
	{ currencyCode: 'TRY', hungarianName: 'Új török lira' },
	{ currencyCode: 'UAH', hungarianName: 'Ukrán hrivnya' },
	{ currencyCode: 'USD', hungarianName: 'Amerikai dollár' },
	{ currencyCode: 'ZAR', hungarianName: 'Dél-Afrikai rand' }
];

export const BRANCH_LIMIT = 20000000;
